import { useEffect } from "react";
import { PageMap, PageOptions, usePageContext } from "./PageContext";
import { Loading } from "@kalyzee/kast-web-sdk/web-components";
import { SessionMode } from "../../contexts/appStore/hooks";
import { AppLoadingView } from "../utils/AppLoadingView";

export interface GoToProps <M extends SessionMode, T extends PageMap[M]> {
  page: T, 
  loadingMode?: "absolute" | "relative",
  params?: any, 
  options?: PageOptions,
}
export const GoTo = ({ 
  page, 
  loadingMode = "absolute",
  params, 
  options
}: GoToProps<any, any>) => {
  const context = usePageContext();
  useEffect(() => {
    context?.goTo?.(page, params, options);
  }, []);
  if (loadingMode === "absolute") {
    <AppLoadingView message="Redirection" />;
  }
  return <Loading style={{ width: "100%", height: "100%" }} message="Redirection ..." />;
}